import React from "react";

export default class PackageUsersNoPrice extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      size: this.props.minimumUsers || 1,
      usersPackage: [],
      showMoreUsersOption: true,
      selectedUser: this.props.minimumUsers || 1,
      minimumUsers: this.props.minimumUsers || 1
    };
  }

  showMoreUsers(){
    if(this.state.showMoreUsersOption) {
      this.setState({
        showMoreUsersOption: false,
        size: this.state.usersPackage.length
      })
    } else {
      this.setState({
        showMoreUsersOption: true,
        size: this.props.minimumUsers || 1
      })
    }
  }

  selectUser(user, usersPackage, clickAction){
    this.props.onSelectingUser(user)

    if(clickAction){
      this.props.onUserClickAction()
    }

    for(var eachUser = 0; eachUser <= usersPackage.length-1; eachUser++){
      var userIndex = parseInt(usersPackage[eachUser].number, 10) - user
      if(userIndex === 0){
        usersPackage[eachUser].value="Selected"
      }
      else {
        usersPackage[eachUser].value=""
      }
    }

    //set the updated users value
    this.setState({
      usersPackage: usersPackage,
      selectedUser: user
    })
  }

  setUserPackage(selectedUser){
    let usersPackage = [], size
    for(var user = this.state.minimumUsers; user <= 20; user++){
      if(user === this.props.minimumUsers) {
        usersPackage.push({number:user,value:"Included"})
      }else{
        usersPackage.push({number:user,value:""})
      }
    }

    if(usersPackage.length>3){
      size = 3
    }else{
      size = 20
    }

    this.setState({
      size: size,
      selectedUser: selectedUser || this.state.minimumUsers
    })

    if(selectedUser!=null){
      this.selectUser(selectedUser,usersPackage, false)
    }else{
      this.setState({
        usersPackage: usersPackage
      })
    }
  }

  componentDidMount() {
    this.setUserPackage(this.props.selectedUser)
  }

  render() {
    var usersList = this.state.usersPackage.slice(0, this.state.size).map(function (singleUser, index) {
      let classNames = require('classnames');
      var userTileClass = classNames({
        'alert': this.state.selectedUser !== singleUser.number,
        'alert alert-success': this.state.selectedUser === singleUser.number
      });
      return(
        <div className={userTileClass} key={index} onClick={()=>{this.selectUser(singleUser.number, this.state.usersPackage, true)}}>
          <div className="row body">
            <div className="col-xs-8">
              {singleUser.number} {singleUser.number === 1? 'User':'Users'}
            </div>
            <div className="col-xs-4 text-right">
              {singleUser.value}
            </div>
          </div>
        </div>
      )
    },this)
    return(
      <div className="panel-body-spacing">
        {usersList}
        <div className="row body no-margin grey-text pointer">
          <div className="col-xs-12">
            {this.state.usersPackage.length > 3 && this.state.showMoreUsersOption && <span onClick={()=>{this.showMoreUsers()}}>Show more</span>}
            {this.state.usersPackage.length > 3 && !this.state.showMoreUsersOption &&<span onClick={()=>{this.showMoreUsers()}}>Show less</span>}
          </div>
        </div>
      </div>
    )
  }
}
